import { useQuery } from '@tanstack/react-query';
import { fetchAuditLog, type AuditRecord } from '../api/adminAudit';

export function useAuditLog(entity: AuditRecord['entity'], entityId?: string) {
  return useQuery<AuditRecord[]>({
    queryKey: ['admin-audit', entity, entityId],
    queryFn: () => {
      if (!entityId) return Promise.resolve([]);
      return fetchAuditLog(entity, entityId);
    },
    enabled: Boolean(entityId),
  });
}
